
import { mapActions } from 'vuex'
import SizeSelect from './size-select.vue'
import CtaMain from './cta-main.vue'
import LoleBackdrop from '~/components/common/lole-backdrop'
import Price from '~/components/price/price'
import LolePicture from '~/components/picture/lole-picture'
import { isProductSellable } from '~/helpers/shopify/product'

export default {
  components: {
    SizeSelect,
    CtaMain,
    LoleBackdrop,
    Price,
    LolePicture,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    wording: {
      type: Object,
      required: true,
    },
    toggleModal: {
      type: Boolean,
      default: false,
    },
    variantInWishlist: {
      type: Boolean,
      default: false,
    },
    noSelectedSize: {
      type: Boolean,
      default: false,
    },
    selectedSize: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedVariant: {
        size: 'M',
      },
    }
  },
  methods: {
    ...mapActions({
      vxCloseAllMobile: 'navigation/closeAllMobile',
      vxCloseAllDesktop: 'navigation/closeAllDesktop',
      vxGoToCheckout: 'product/goToCheckout',
    }),
    goToCheckout() {
      this.vxGoToCheckout(this.getGAIdSession())
    },
    isSellable() {
      return isProductSellable(this.$i18n.locale, this.$config)
    },
    getCustomAttributeValue(key) {
      const attribute = this.product.customAttributes.find((attribute) => {
        return attribute.key === key
      })
      return attribute ? attribute.value : ''
    },
    closeAll() {
      this.$emit('closeModal')
      // this.vxCloseAllMobile()
      // this.vxCloseAllDesktop()
    },
    getGAIdSession() {
      const ga = window[window.GoogleAnalyticsObject]
      if (ga && ga.getAll) {
        return ga.getAll()[0].get('linkerParam')
      } else return null
    },
    selectSize(size) {
      this.$emit('selectSize', size)
    },
    addToCart() {
      this.closeAll()
      this.$emit('addToCart')
    },
    removeFromWishlist() {
      this.closeAll()
      this.$emit('removeFromWishlist')
    },
    addToWishlist() {
      this.closeAll()
      this.$emit('addToWishlist')
    },
  },
}
